import React from "react";
import Header from "../components/Header";
import FooterSection from "../components/FooterSection";
import ListExperience from "../components/ListExperience";


const ListExperiencePage = () => {
    return (
        <div>
            <Header />
            <ListExperience />
            <FooterSection />
        </div>
    );
};

export default ListExperiencePage;
